import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { SelectContext } from '../../context/SelectContext.js';
import { useSelectRoot } from './hooks/useSelectRoot.js';

var _excluded = ["menuProps", "children"];
var SelectRoot = /*#__PURE__*/React.memo(function (_ref) {
  var menuSettings = _ref.menuProps,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSelectRoot = useSelectRoot(menuSettings),
    triggerRef = _useSelectRoot.triggerRef,
    buttonProps = _useSelectRoot.buttonProps,
    menuProps = _useSelectRoot.menuProps,
    state = _useSelectRoot.state;
  return /*#__PURE__*/React.createElement(SelectContext.Provider, {
    value: {
      triggerRef: triggerRef,
      state: state,
      triggerProps: buttonProps,
      menuProps: menuProps,
      listBoxSettings: rest
    }
  }, children);
});

export { SelectRoot };
//# sourceMappingURL=SelectRoot.js.map
